import React from "react"
import PropTypes from "prop-types"

import WritingLanguageChoices from './WritingLanguageChoices'
import WritingResponse from './WritingResponse'

class AllWritingResponses
 extends React.Component {

   constructor(props) {
     super(props)

     this.state = {
       selectedLanguage: '',
       loading: true
     }

     this.renderTopics = this.renderTopics.bind(this)
     this.clickButton = this.clickButton.bind(this)
   }

   componentWillMount() {
     $.ajax({
       url: `weekly_writing_practice_ajax`,
       dataType: 'JSON',
       type: 'GET',
       header: {
         'Content-Type': 'application/json'
       },
       success: (data) => {
         this.setState({
           currentUser: data.data.current_user,
           responses: data.data.responses,
           languages: data.data.languages,
           topic: data.data.writing_topic,
           loading: false
         })
       },
       error: function(xhr, status, err) {
         console.log(err)
       }.bind(this)
     });
   }

  renderTopics() {
     if(this.state.selectedLanguage === '') {
       return this.state.responses.map((responses,index) => {
         return (<WritingResponse response={responses} key={index} clapLottie={this.props.clapLottie} clapIcon={this.props.clapIcon} currentUser={this.state.currentUser}/>)
       })
    } else {
      return this.state.responses.map((responses,index) => {
        if(responses.language_id === this.state.selectedLanguage) {
          return (<WritingResponse response={responses} key={index} clapLottie={this.props.clapLottie} clapIcon={this.props.clapIcon} currentUser={this.state.currentUser}/>)
        }
      })
    }
  }

  clickButton(lang) {
    this.setState({
      selectedLanguage: lang.id
    })
  }

  render() {
    if(this.state.loading) {
      return null
    }
    return(
      <div style={{margin: 'auto', padding: 12, textAlign: 'center'}}>
        <h3 className="darkBlue" style={{fontWeight: 600}}>{this.state.topic.title}</h3>
        <WritingLanguageChoices onClick={this.clickButton} languages={this.state.languages} onAllClick={() => this.setState({selectedLanguage: ''})} selectedLanguage={this.state.selectedLanguage}/>
        <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
        {this.renderTopics()}
        </div>
      </div>
    )
  }

}

export default AllWritingResponses;
